/* Tiny Confetti – tam ekran kapsama + güvenli tetik */
(function () {
  // ---------- Canvas (tam viewport) ----------
  function makeCanvas() {
    const doc = document;
    const c = doc.createElement('canvas');
    c.className = 'bb-confetti';
    c.style.cssText = [
      'position:fixed','inset:0','pointer-events:none','z-index:2147483647',
      'transform:none !important','width:100vw !important','height:100vh !important'
    ].join(';');
    doc.documentElement.appendChild(c);
    return c;
  }
  function R(a,b){ return Math.random()*(b-a)+a; }

  // ---------- Ana patlama ----------
  // angleDeg: parçacıkların merkez açısı (derece). -90 = yukarı, 0 = sağa, 90 = aşağı, 180/-180 = sola
  function burst(opts) {
    opts = opts || {};
    const particleCount = opts.particleCount ?? 220;
    const spreadDeg     = opts.spread ?? 80;                  // derece
    const angleDeg      = opts.angleDeg ?? -90;               // merkez açı
    const startVel      = opts.startVelocity ?? 13;
    const decay         = opts.decay ?? 0.89;
    const gravity       = opts.gravity ?? 0.6;
    const colors        = opts.colors || ['#f94144','#f3722c','#f8961e','#f9844a','#f9c74f','#90be6d','#43aa8b','#577590','#e4106f'];
    const scalar        = opts.scalar ?? 1;
    const originX       = opts.originX ?? 0.5;                // 0..1
    const originY       = opts.originY ?? 0.22;               // 0..1 (CSS)

    const canvas = makeCanvas();
    const ctx = canvas.getContext('2d');

    // Boyut + DPR
    let Wcss = 0, Hcss = 0, DPR = 1;
    function onResize() {
      Wcss = window.innerWidth  || document.documentElement.clientWidth;
      Hcss = window.innerHeight || document.documentElement.clientHeight;
      DPR  = window.devicePixelRatio || 1;
      canvas.width  = Math.max(1, Math.floor(Wcss * DPR));
      canvas.height = Math.max(1, Math.floor(Hcss * DPR));
      ctx.setTransform(1,0,0,1,0,0);
      ctx.scale(DPR, DPR); // çizim birimi = CSS px
    }
    onResize();
    window.addEventListener('resize', onResize);

    // Parçacıklar (CSS koordinatı)
    const spreadRad = spreadDeg * Math.PI/180;
    const ang0 = angleDeg * Math.PI/180;
    const half = spreadRad / 2;

    let parts = [];
    for (let i=0; i<particleCount; i++){
      const ang = ang0 + R(-half, half);
      const spd = startVel + R(0,8);
      parts.push({
        x: Wcss * originX, y: Hcss * originY,
        w: R(6,10)*scalar, h: R(2,6)*scalar,
        c: colors[(Math.random()*colors.length)|0],
        vx: Math.cos(ang)*spd, vy: Math.sin(ang)*spd,
        r: R(0,360), vr: R(-10,10), a: 1
      });
    }

    let frame;
    function tick(){
      ctx.clearRect(0,0,Wcss,Hcss);
      for (let i=0;i<parts.length;i++){
        const p = parts[i];
        p.x += p.vx;
        p.y += (p.vy += gravity);
        p.vx *= decay; p.vy *= decay;
        p.r += p.vr;  p.a *= 0.995;

        ctx.save();
        ctx.globalAlpha = p.a > 0 ? p.a : 0;
        ctx.translate(p.x,p.y);
        ctx.rotate(p.r*Math.PI/180);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h);
        ctx.restore();
      }
      parts = parts.filter(p=>p.a>0.05 && p.y < Hcss+60 && p.x > -60 && p.x < Wcss+60);

      if (parts.length) frame = window.requestAnimationFrame(tick);
      else {
        window.cancelAnimationFrame(frame);
        window.removeEventListener('resize', onResize);
        canvas.remove();
      }
    }
    tick();
  }

  // ---------- Ekranı dolduran koreografi ----------
  function burstScreen() {
    // Sol kenardan sağa doğru (açı 0°)
    burst({ particleCount: 220, spread: 120, startVelocity: 14, originX: 0.08, originY: 0.18, angleDeg: 0 });
    setTimeout(()=> {
      // Orta yukarıdan yukarı doğru
      burst({ particleCount: 260, spread: 150, startVelocity: 16, originX: 0.5, originY: 0.20, angleDeg: -90 });
    }, 120);
    setTimeout(()=> {
      // Sağ kenardan sola doğru (açı 180°)
      burst({ particleCount: 220, spread: 120, startVelocity: 14, originX: 0.92, originY: 0.18, angleDeg: 180 });
    }, 240);
    setTimeout(()=> {
      // Alt orta noktadan yukarı (ekranın alt kısmını da boyasın)
      burst({ particleCount: 200, spread: 160, startVelocity: 15, originX: 0.5, originY: 0.65, angleDeg: -100 });
    }, 360);
  }
// ---------- Tüm ekranı dolduran karo yağmuru ----------
  // Ayarlar: cols (kolon), rows (satır), pcount (parçacık), spread, velocity, stagger (ms)
  function burstFill(opts = {}) {
    const cols     = opts.cols ?? 6;
    const rows     = opts.rows ?? 4;
    const pcount   = opts.pcount ?? 110;
    const spread   = opts.spread ?? 150;
    const velocity = opts.velocity ?? 13;
    const stagger  = opts.stagger ?? 55; // her mikro-patlama arası
    const marginX  = 0.06;               // kenarlardan boşluk (oran)
    const marginY  = 0.10;

    const stepX = (1 - 2*marginX) / cols;
    const stepY = (1 - 2*marginY) / rows;

    let idx = 0;
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const originX = marginX + (c + 0.5) * stepX;
        const originY = marginY + (r + 0.5) * stepY;
        const angle   = -90 + R(-25, 25);         // çoğunlukla yukarı
        const delay   = idx * stagger + R(0, 25); // ufak jitter

        setTimeout(() => {
          burst({
            particleCount: pcount,
            spread: spread,
            startVelocity: velocity,
            originX, originY,
            angleDeg: angle
          });
        }, delay);

        idx++;
      }
    }
  }
  // ---------- Erken tetiklemeyi kes ----------
  function isVisible(el){
    if (!el || !el.isConnected) return false;
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function nearestForm(el){
    while (el && el !== document.body) {
      if (el.tagName === 'FORM') return el;
      el = el.parentElement;
    }
    return null;
  }
  function onNewsletterSuccess(cb){
    let fired = false;
    const fire = () => { if (fired) return; fired = true; cb(); };
    const SELECTORS = [
      '.form-notification.success',
      '.form-status--success', '.form__message--success',
      '.newsletter-success', '.thb-notice.success',
      '.alert.alert--success', '.signup-message--success'
    ].join(',');
    const mo = new MutationObserver(() => {
      const hits = Array.from(document.querySelectorAll(SELECTORS));
      for (const el of hits) {
        if (!isVisible(el)) continue;
        const f = nearestForm(el);
        if (f && (f.querySelector('[name="contact[email]"]') || (f.id||'').toLowerCase().includes('newsletter'))) {
          fire(); mo.disconnect(); break;
        }
        if (!f) { fire(); mo.disconnect(); break; }
      }
    });
    mo.observe(document.body, { childList:true, subtree:true });
  }

  // Teşhis isterse
  function __diag(){
    const el = document.querySelector('canvas.bb-confetti');
    if (!el) return 'no-canvas';
    const r = el.getBoundingClientRect(), cs = getComputedStyle(el);
    return { vw: innerWidth, vh: innerHeight, dpr: devicePixelRatio,
             cw: el.width, ch: el.height, cssw: cs.width, cssh: cs.height, rect: {w:r.width, h:r.height} };
  }
  window.BBConfetti = { burst, burstScreen, burstFill, onNewsletterSuccess, __diag };
})();
